/* UrbanNomado Theme JS - Phase 2 Migration */
(function () {
  'use strict';

  // Cart badge live-update if cart count changes
  document.addEventListener('DOMContentLoaded', function () {
    const cartBadges = document.querySelectorAll('.cart-badge, .mobile-cart-button .cart-badge');
    if (cartBadges.length) {
      console.log('Cart badge updated');
    }
  });

  // Smooth scroll for anchor links
  document.addEventListener('click', function (e) {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const target = document.querySelector(a.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Newsletter form: client-side email validation feedback
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form.matches('.nl-incentive__form')) return;
    const email = form.querySelector('input[type="email"]');
    if (!email || !email.value.includes('@')) {
      e.preventDefault();
      email && email.focus();
    }
  });
})();
